/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CHE_CHECKBOOKS_ITEM = {
  id: 'checks_sidebar_checkbooks',
  screenId: 'fin-che-checkbooks',
  label: 'Chequeras',
  description: 'Alta de chequeras por cuenta bancaria.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás cada chequera vinculada a una cuenta bancaria. Al pagar con cheque propio en Pagos elegís la chequera y el número.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Necesitás cuentas bancarias cargadas en Finanzas → Bancos y permiso de lectura sobre ellas.',
        ],
      },
      {
        title: 'Lista',
        bullets: [
          'Columnas: Descripción, Cuenta bancaria, Moneda, Desde, Hasta, Próximo nº (número sugerido para el próximo cheque).',
          'Tocá una fila para ver el detalle (solo lectura).',
          'Podés exportar el listado.',
        ],
      },
      {
        title: 'Alta de chequera',
        intro: 'El botón + abre «Nueva chequera». Campos:',
        fields: [
          { label: 'Cuenta bancaria', description: 'Cuenta desde la que se emiten los cheques. Obligatoria.' },
          { label: 'Descripción', description: 'Nombre interno (por ejemplo «Chequera pesos cuenta corriente»). Obligatoria.' },
          { label: 'Número desde / hasta', description: 'Opcionales. Rango de números de la chequera física. Si completás ambos, «hasta» debe ser mayor o igual que «desde».' },
        ],
        paragraphs: [
          'Tocá «Crear chequera». En esta pantalla no hay edición: solo alta y consulta.',
        ],
      },
    ],
  },
}
